import { baseRequest } from '@/utils/request'

const request = (url, ...arg) => baseRequest(`/biz/mrstorestaff/` + url, ...arg)

export default {
	mrStoreStaffPage(data) {
		return request('page', data, 'get')
	},
	mrStoreStaffList(data) {
		return request('list', data, 'get')
	},
	mrStoreStaffChannelOptions() {
		return baseRequest('/auth/c/channel/staff-selector', null, 'get')
	},
	mrStoreStaffSubmitForm(data, edit = false) {
		return request(edit ? 'edit' : 'add', data)
	},
	mrStoreStaffChangeStatus(data) {
		return request('statusChange', data)
	},
	mrStoreStaffDelete(data) {
		return request('delete', data)
	},
	mrStoreStaffDetail(data) {
		return request('detail', data, 'get')
	},
	mrStoreStaffSaveAccessBundle(staffId, data) {
		return request(`${staffId}/access-bundle`, data, 'put')
	},
	mrStoreStaffAccessById(staffId) {
		return request(`${staffId}/access`, null, 'get')
	},
	mrStoreStaffApproveAccessReview(staffId, data) {
		return request(`${staffId}/access-review`, data, 'put')
	},
	mrStoreStaffAccessHistory(staffId) {
		return request(`${staffId}/access-history`, null, 'get')
	},
	mrStoreStaffWechatBindingCheck(data) {
		return request('wechatBindingCheck', data, 'get')
	},
	mrStoreStaffUnbindWechat(data) {
		return request('unbindWechat', data)
	},
	mrStoreStaffRepairWechatBinding(data) {
		return request('repairWechatBinding', data)
	},
	mrStoreStaffStatusHistory(data) {
		return request('statusHistory', data, 'get')
	},
	mrStoreStaffOffboardingArchives(data) {
		return request('offboardingArchives', data, 'get')
	},
	mrStoreStaffOffboardingCheck(data) {
		return request('offboardingCheck', data, 'get')
	},
	mrStoreStaffSettleOffboarding(data) {
		return request('offboardingArchive/settle', data)
	}
}
